import { render, staticRenderFns } from "./GeoDataMap.vue?vue&type=template&id=38d66e3c&scoped=true"
import script from "./GeoDataMap.vue?vue&type=script&setup=true&lang=js"
export * from "./GeoDataMap.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GeoDataMap.vue?vue&type=style&index=0&id=38d66e3c&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d66e3c",
  null
  
)

export default component.exports